export const PaymentScope = {
  PLAN: 'PLAN',
  TOP_UP: 'TOP_UP',
  REPORT_UPSELL: 'REPORT_UPSELL',
} as const;
export type TPaymentScope = (typeof PaymentScope)[keyof typeof PaymentScope];
